import fetch from 'isomorphic-fetch';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { GF_DOTCOM_OKENDO_APP_USER_ID } = publicRuntimeConfig;

const fetchReviews = async (url) => {
    try {
        const response = await fetch(`${url}`)
        if (response.status === 200) {
            const json = await response.json();
            return json;
        }
        return null;
    } catch (e) {
        return null;
    }
}

// eslint-disable-next-line import/prefer-default-export,  no-unused-vars
export const fetchOkendoReviews = async (reviewsBy, id) => {
    try {
        let endpoint = ""
        if (reviewsBy === "product") {
            endpoint = `/products/shopify-${id}`
        }
        if (reviewsBy === "group") {
            endpoint = `/collections/${id}`
        }

        const okendoApiUrls = [
            `https://api.okendo.io/v1/stores/${GF_DOTCOM_OKENDO_APP_USER_ID}${endpoint}/reviews`,
            `https://api.okendo.io/v1/stores/${GF_DOTCOM_OKENDO_APP_USER_ID}${endpoint}/review_aggregate`
        ]

        const [reviews, aggregate] = await Promise.all(
            okendoApiUrls.map(url => fetchReviews(url))
        );

        return {
            ...reviews,
            ...aggregate
        }
    } catch (e) {
        return null;
    }
};

